exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wallet-template {\n    margin: 50px auto;\n    width: 50%;\n    padding: 10px;\n    border: 1px solid #ddd;\n}", ""]);

// exports
